import { JSONSchema6 } from "json-schema";

const updateChargePermissionSchema: JSONSchema6 = {
    title: "UpdateChargePermission",
    description: "Update the Charge Permission with your order metadata. Some of the values may be shared with the buyer. If subscription detail changes, you can also update recurringMetadata.",
    properties: {
        "pathParam": {
            title: "chargePermissionId",
            type: "string",
        },
        "header": {
            type: "object",
             properties: {
                 "x-amz-pay-simulation-code": {
                     title: "x-amz-pay-simulation-code",
                     type: "string"
                 }
             },
        },
        "payload": {
            type: "object",
            properties: {
                "recurringMetadata": {
                    type: "object",
                    properties: {
                      "frequency": {
                        type: "object",
                        properties: {
                          "unit": {
                            type: "string",
                            enum: ["", "Year", "Month", "Week", "Day", "Variable"] }
                          ,
                          "value": {
                            type: "string"
                          }
                        }
                      },
                      "amount": {
                        type: "object",
                        description: "Transaction amount",
                        properties: {
                          "amount": {
                            type: "string"
                          },
                          "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"] }
                          }
                        }
                    }
                },
                "merchantMetadata": {
                    type: "object",
                    properties: {
                        "merchantReferenceId": {
                          type: "string",
                          maxLength: 256
                        },
                        "merchantStoreName": {
                          type: "string",
                          maxLength: 50
                        },
                        "noteToBuyer": {
                          type: "string",
                          maxLength: 255
                        },
                        customInformation: {
                          type: "string",
                          maxLength: 4096
                        }
                    }
                }
            }
        }
    },
    required: ["pathParam"]
}

export default updateChargePermissionSchema
